module.exports = __webpack_public_path__ + "static/media/entertainment-industry.563198cf.svg";